import { BaseEntity } from './base-entity';
import {Invoice} from './invoice';
import {SoftDeleteEntity} from './soft-delete-entity';


export class InvoiceLineItem extends SoftDeleteEntity{
    public name: string;
    public invoice: Invoice;
    public numberOfItems: number;
    public amount: number;
    public singleAmount: number;
    public feeType;
    public vatRate: number;
}
